module.exports = __webpack_public_path__ + "images/icon/btn_pdf-9c252163.svg";